import { useState, useEffect } from "react";

// Base API relativa: funziona su qualsiasi dominio; in dev Vite fa da proxy (vedi vite.config.js).
const wsurl = "/api/index.php?p=";

function MIMEURLToByte(imgurlb64){
    let mime = imgurlb64.split(',')[1];
    return mime;
  }
const getFromDB = (cb, cberr)=>{
    fetch(wsurl+"/cartellone",{
        method:"GET",
        headers:{
          "Accept":"application/json",
        },
    }).then((response)=>{
        if(!response.ok) throw new Error("HTTP "+response.status);
        return response.json();
    })
    .then((posarray)=>{
        cb(posarray);
    }).catch((error)=>{
        if(cberr) cberr(error);
    });
}
const delToDB = (cartellone,busyfunction,logfunction,cb) =>{
  busyfunction(true);
  fetch(wsurl+"/cartellone",{
      method:"DELETE",
      headers:{
        "Content-Type":"application/json",
      },
      body: JSON.stringify(cartellone)
  }).then((response)=>{ if(!response.ok) throw new Error("HTTP "+response.status); return response.json(); })
      .then((toolsarray)=>{
      busyfunction(false);
      cb(toolsarray);
  }).catch((error)=>{
      busyfunction(false);
      logfunction("errore ");
  });

};

const putToDB = (cartellone,busyfunction,logfunction,cb) =>{
  busyfunction(true);
  fetch(wsurl+"/cartellone",{
      method:"PUT",
      headers:{
        "Content-Type":"application/json",
      },
      body: JSON.stringify(cartellone)
  }).then((response)=>{ if(!response.ok) throw new Error("HTTP "+response.status); return response.json(); })
      .then((toolsarray)=>{
      busyfunction(false);
      cb(toolsarray);
  }).catch((error)=>{
      busyfunction(false);
      logfunction("errore ");
  });

};

const postNewCap = (imagesrc, cartelid, busyfunction,cb,cberr) =>{
  const addelem = {cid:cartelid,imgsrc:imagesrc};

  busyfunction(true);

  fetch(wsurl+"/cntx",{
      method:"POST",
      headers:{
        "Content-Type":"application/json",
      },
      body: JSON.stringify(addelem)
  }).then((response)=>{ if(!response.ok) throw new Error("HTTP "+response.status); return response.json(); })
      .then((elem)=>{
      busyfunction(false);
      cb(elem);
  }).catch((error)=>{
      busyfunction(false);
      if(cberr) cberr(error);
  });

};

const postTitle = (cartellone,logfunction,cb) =>{
  fetch(wsurl+"/title",{
      method:"POST",
      headers:{
        "Content-Type":"application/json",
      },
      body: JSON.stringify(cartellone)
  }).then((response)=>{ if(!response.ok) throw new Error("HTTP "+response.status); return response.json(); })
      .then((elem)=>{
      logfunction("success");
  }).catch((error)=>{
      logfunction("errore ");
  });

};

const postToDB = (cartellone,busyfunction,logfunction,cb) =>{
    busyfunction(true);
    fetch(wsurl+"/cartellone",{
        method:"POST",
        headers:{
          "Content-Type":"application/json",
        },
        body: JSON.stringify(cartellone)
    }).then((response)=>{ if(!response.ok) throw new Error("HTTP "+response.status); return response.json(); })
        .then((elem)=>{
        busyfunction(false);
        cb(elem);
    }).catch((error)=>{
        busyfunction(false);
        logfunction("errore ");
    });

  };

  const postForCsvs = (ids,busyfunction,logfunction,cb) =>{
    fetch(wsurl+"/csv",{
        method:"POST",
        headers:{
          "Content-Type":"application/json",
        },
        body: JSON.stringify(ids)
    }).then((response)=> response.text())
        .then((csvfile)=>{
          var anchor = document.createElement('a');
          anchor.download = "selected.csv";
          if(window.URL.createObjectURL) {
            var blobObject = new Blob([csvfile], {type: 'text/csv'});
            anchor.href = window.URL.createObjectURL(blobObject);
            anchor.click();
          }
    }).catch((error)=>{
    });

  };

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
  }

  function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
      function handleResize() {
        setWindowDimensions(getWindowDimensions());
      }

      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
  }

  export {wsurl,postTitle, postNewCap, postForCsvs, putToDB, delToDB, getFromDB, MIMEURLToByte, postToDB, getWindowDimensions,useWindowDimensions};
